import { memo, useCallback, useEffect, useId, useState } from "react";
import Breadcrumb from "components/shared/breadcrumb";
import { CSSTransition } from "react-transition-group";
import useFetch from "hooks/useFetch";
import SwitchButton from "components/shared/switchButton";
import TimeList from "./time-list";
import { readTime, sendTime } from "utils/schedule-converter";
import { timeToMinutes } from "utils";
import { toast } from "react-toastify";
import MasterAPI from "service/master";
import Loading from "components/shared/loading";

const Timing = () => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const { isLoading, data, error } = useFetch("/api/profile/get");
    const [weekSchedule, setWeekSchedule] = useState([]);
    const [allDay, setAllDay] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const fullyTimeId = useId();

    useEffect(() => {
        if (!isLoading && !error) {
            setWeekSchedule(readTime(data.data?.module_fields?.time_table?.week_schedule || []));
            setAllDay(!!data.data?.module_fields?.time_table?.all_day);
        }

        // eslint-disable-next-line
    }, [data, isLoading])

    const setWeekScheduleCallback = useCallback(val => {
        setWeekSchedule(val);
    }, [])

    const setActiveTabCallback = useCallback(val => {
        setActiveTab(val);
    }, []);

    const validator = () => {
        if (allDay)
            return true;

        let existsError = false;

        weekSchedule.forEach((time, i) => {
            if (!existsError) {
                let errorMsg = null;

                if (time.start === null || time.end === null) {
                    errorMsg = "شروع و پایان باید مقدار داشته باشند";
                } else {
                    const start = timeToMinutes(time.start.replace("00/00/00 ", ""));
                    const end = timeToMinutes(time.end.replace("00/00/00 ", ""));

                    if (start >= end)
                        errorMsg = "ساعت پایان باید بعد از ساعت شروع باشد";
                }

                if (errorMsg) {
                    existsError = true;
                    toast.error(errorMsg);
                    setActiveTab(time.day);

                    setWeekSchedule(prev => {
                        const newState = [...prev];
                        newState[i] = {
                            ...newState[i],
                            error: true
                        }

                        return newState;
                    });
                }
            }
        });

        return !existsError;
    }

    const submitHandler = async () => {
        if (!validator())
            return;

        if (submitLoading)
            return;

        setSubmitLoading(true);
        try {
            const res = await MasterAPI({
                method: "PUT",
                payloadType: 3,
                url: "/api/profile/edit_module_fields",
                data: {
                    module_fields: {
                        time_table: {
                            all_day: allDay,
                            week_schedule: sendTime(weekSchedule)
                        }
                    }
                },
                callback: () => setSubmitLoading(false)
            })

            toast.success(res.message);
        } catch (e) {
            toast.error(e.message);
        }
    }

    return (
        <div className="m-container">
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">ساعت کاری فروشنده</h1>
                    <Breadcrumb data={[
                        { title: "اطلاعات فروشگاه" },
                        { title: "ساعت کاری فروشنده" }
                    ]} />
                </div>

                <button
                    className={`bg-primary-100 hover:bg-primary-200 px-7 transition-colors text-white rounded-md fit-center text-sm h-10 relative overflow-hidden${submitLoading ? " cursor-progress" : ""}`}
                    onClick={submitHandler}
                >
                    <i className="fa-light fa-file ml-2"></i>
                    ثبت اطلاعات

                    <CSSTransition in={submitLoading} timeout={200} unmountOnExit={true}>
                        <span className="pos-cover bg-primary-200 fit-center anim-c4">
                            <i className="fa-solid fa-spinner spin"></i>
                        </span>
                    </CSSTransition>
                </button>
            </div>

            <div className="wrap-box tp-22">
                {
                    !isLoading ? (
                        <>
                            <div className="flex items-center">
                                <SwitchButton
                                    id={fullyTimeId}
                                    checked={allDay}
                                    changeHandler={() => setAllDay(prev => !prev)}
                                />

                                <label htmlFor={fullyTimeId} className="font-medium mr-2 cursor-pointer noselect text-gray-900 dark:text-slate-100">24 ساعته</label>
                            </div>

                            <CSSTransition in={allDay} timeout={200} appear={true}>
                                <span className="anim-c4 text-sm font-medium mt-4 block tp-6">
                                    فروشگاه شما در تمامی ایام، به طور ۲۴ ساعته فعال است.
                                </span>
                            </CSSTransition>

                            <CSSTransition in={!allDay} timeout={{ enter: 200, exit: 0 }} unmountOnExit={true} appear={true}>
                                <div className="anim-c8 mt-2">
                                    <TimeList
                                        data={weekSchedule}
                                        setData={setWeekScheduleCallback}
                                        activeTab={activeTab}
                                        setActiveTab={setActiveTabCallback}
                                    />
                                </div>
                            </CSSTransition>
                        </>
                    ) : (
                        <div className="flex justify-center">
                            <Loading className="loading-c5" />
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default memo(Timing);